import { render, staticRenderFns } from "./DispatchMap.vue?vue&type=template&id=efd1f2d6&scoped=true&"
import script from "./DispatchMap.vue?vue&type=script&lang=js&"
export * from "./DispatchMap.vue?vue&type=script&lang=js&"
import style0 from "./DispatchMap.vue?vue&type=style&index=0&id=efd1f2d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd1f2d6",
  null
  
)

export default component.exports